import { Box, Text } from '@chakra-ui/react';

export interface ChangelogData {
    date: string;
    updates: string[];
}

export const ChangelogEntry = (props: ChangelogData) => {
    return (
        <Box className={'note-entry'}>
            <Text className="note-header">{props.date}</Text>
            <ul className="note-list">
                {props.updates.map((note, index) => (
                    <li key={`note_${index}`}>{note}</li>
                ))}
            </ul>
        </Box>
    );
};
